// Style sheets
require("./scss/main.scss");
require("../modules/widerruf/widerruf.scss");

// JS
require("./js/global");
require("./js/product-configurator");
require("./js/shop");
require("./js/cart");
require("./js/single-product");